import { mapToApiCollectedAccessories } from './accessoriesMapper';
import {
    ServiceOrdersCompletion,
    ServiceOrdersStartInfo,
} from '../../../serviceOrders/serviceOrders/serviceOrderExecution.types';
import {
    ApiServiceOrdersCompletion,
    ApiServiceOrdersStartInfo,
} from '../../types/serviceOrder/serviceOrderExecutionApi.types';
import { NonEmptyString } from 'io-ts-types';

export const mapToApiServiceOrdersStartInfos = (startInfo: ServiceOrdersStartInfo): ApiServiceOrdersStartInfo => ({
    order_ids: [...startInfo.orderIds] as NonEmptyString[],
    started_at: startInfo.startedAt.toISOString(),
    general_information: startInfo.generalInformation,
    collected_accessories:
        startInfo.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(startInfo.collectedAccessories)
            : undefined,
});

export const mapToApiServiceOrdersCompletion = (completion: ServiceOrdersCompletion): ApiServiceOrdersCompletion => ({
    order_ids: [...completion.orderIds] as NonEmptyString[],
    started_at: completion.startedAt !== undefined ? completion.startedAt.toISOString() : undefined,
    completed_at: completion.completedAt.toISOString(),
    general_information: completion.generalInformation,
    collected_accessories:
        completion.collectedAccessories !== undefined
            ? mapToApiCollectedAccessories(completion.collectedAccessories)
            : undefined,
});
